import React from 'react';
import { Router, Route, Redirect } from 'react-router';
import { Container as Base } from 'modules/base';
import { Component as Home, HomeSidebar } from 'modules/home';
import { Search, SearchSideBar } from 'modules/search';
import { Register, MeSetting, Login } from 'modules/sidebar';
import { CollectionLayout } from 'modules/collection';

const App = ({
  history,
  defaultPage
}) => {
  return (
    <Router history={history}>
      <Route component={Base}>

        <Redirect from="/" to={`/home`} />
        <Route
          path="/home"
          components={{
            sidebar: HomeSidebar,
            body: Home
          }}
        />
        <Route
          path="/search"
          components={{
            sidebar: HomeSidebar,
            body: Search
          }}
        />
        <Route
          path="/me"
          components={{
            sidebar: HomeSidebar,
            body: MeSetting
          }}
        />
        <Route
          path="/register"
          components={{
            sidebar: HomeSidebar,
            body: Register
          }}
        />
        <Route
          path="/login"
          components={{
            sidebar: HomeSidebar,
            body: Login
          }}
        />
        <Route
          path="/collection"
          components={{
            sidebar: HomeSidebar,
            body: CollectionLayout
          }}
        />

      </Route>
    </Router>
  );
}

export default App;



/** WEBPACK FOOTER **
 ** ./src/app/modules/app/components/Component.js
 **/